import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { routeMeta, applyPageMeta } from "@/lib/seo";

export const PageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    applyPageMeta(routeMeta(pathname));
  }, [pathname]);

  return null;
};
